// 消息
export default [{ // 资讯列表
  path: '/informationList',
  name: 'informationList',
  component: resolve => require(['@/views/information/informationList.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 消息详情
  path: '/informationDetails',
  name: 'informationDetails',
  component: resolve => require(['@/views/information/informationDetails.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/information/information.js